/**
 * @generated SignedSource<<b527fc184e3b4281916729057fd3f2c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type people_issueFieldPeopleInlineEditFull_PeopleInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"people_issueFieldPeopleInlineEditFull_PeopleInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "people_issueFieldPeopleInlineEditFull_PeopleInlineEditView_fragmentRef";
};
export type people_issueFieldPeopleInlineEditFull_PeopleInlineEditView_fragmentRef$key = {
  readonly " $data"?: people_issueFieldPeopleInlineEditFull_PeopleInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"people_issueFieldPeopleInlineEditFull_PeopleInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "people_issueFieldPeopleInlineEditFull_PeopleInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "people_issueFieldPeopleInlineEditFull_PeopleInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraPeopleField"
};

(node as any).hash = "c3e51c4b22a7f8decfb864ad53ef478f";

export default node;
